import { render } from "./form-edit-role.vue?vue&type=template&id=45efbfda"
import script from "./form-edit-role.vue?vue&type=script&lang=js"
export * from "./form-edit-role.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__